import React, { useState } from 'react';
import API from '../utils/api';

const SERVICES = [
  '👰 Bridal Makeup',
  '💇 Hair Styling & Colour',
  '✨ Facial Treatment',
  '🌿 Skincare & Glow',
  '🎀 Party Makeup',
  '💆 Hair Spa',
  '🌸 Glow Treatment',
  '🌺 Threading & Waxing',
];

const TIME_SLOTS = [
  '9:00 AM','9:30 AM','10:00 AM','10:30 AM','11:00 AM','11:30 AM',
  '12:00 PM','12:30 PM','1:00 PM','1:30 PM','2:00 PM','2:30 PM',
  '3:00 PM','3:30 PM','4:00 PM','4:30 PM','5:00 PM','5:30 PM',
  '6:00 PM','6:30 PM','7:00 PM','7:30 PM',
];

const EMPTY = { name:'', phone:'', email:'', service:'', date:'', time:'', message:'' };

export default function AppointmentForm() {
  const [form, setForm]       = useState(EMPTY);
  const [errors, setErrors]   = useState({});
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [serverErr, setServerErr] = useState('');

  const today = new Date().toISOString().split('T')[0];

  const validate = () => {
    const e = {};
    if (!form.name.trim())    e.name    = 'Name is required';
    if (!form.phone.trim())   e.phone   = 'Phone is required';
    else if (!/^\+?[\d\s\-]{7,15}$/.test(form.phone)) e.phone = 'Enter a valid phone number';
    if (form.email && !/\S+@\S+\.\S+/.test(form.email)) e.email = 'Enter a valid email';
    if (!form.service)        e.service = 'Please select a service';
    if (!form.date)           e.date    = 'Please choose a date';
    if (!form.time)           e.time    = 'Please choose a time';
    return e;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
    if (errors[name]) setErrors(er => ({ ...er, [name]: '' }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setServerErr('');
    const errs = validate();
    if (Object.keys(errs).length) { setErrors(errs); return; }

    setLoading(true);
    try {
      const res = await API.post('/appointments', form);
      if (res.data.success) {
        setSuccess(true);
        setForm(EMPTY);
        setErrors({});
      }
    } catch (err) {
      const msg = err.response?.data?.message
        || err.response?.data?.errors?.[0]
        || 'Something went wrong. Please try again.';
      setServerErr(msg);
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="booking-success">
        <div className="booking-success__icon">🌸</div>
        <h3 className="booking-success__title">Appointment Booked!</h3>
        <p className="booking-success__msg">
          Thank you! We've received your booking and will confirm shortly via phone or WhatsApp.
        </p>
        <button className="booking-success__btn" onClick={() => setSuccess(false)}>
          Book Another Appointment
        </button>
      </div>
    );
  }

  return (
    <form className="booking-form" onSubmit={handleSubmit} noValidate>
      <h3 className="booking-form__title">Reserve Your Experience ✦</h3>
      <p className="booking-form__sub">Complete the form — we'll confirm your booking shortly</p>

      {serverErr && <div className="booking-form__server-err">{serverErr}</div>}

      <div className="booking-form__row">
        <div className="booking-form__group">
          <label className="booking-form__label">Full Name *</label>
          <input
            type="text" name="name" value={form.name}
            onChange={handleChange} placeholder="e.g. Priya Sharma"
            className={`booking-form__input${errors.name ? ' error' : ''}`}
          />
          {errors.name && <span className="booking-form__err">{errors.name}</span>}
        </div>
        <div className="booking-form__group">
          <label className="booking-form__label">Phone *</label>
          <input
            type="tel" name="phone" value={form.phone}
            onChange={handleChange} placeholder="+91 98765 43210"
            className={`booking-form__input${errors.phone ? ' error' : ''}`}
          />
          {errors.phone && <span className="booking-form__err">{errors.phone}</span>}
        </div>
      </div>

      <div className="booking-form__group">
        <label className="booking-form__label">Email (Optional)</label>
        <input
          type="email" name="email" value={form.email}
          onChange={handleChange} placeholder="priya@email.com"
          className={`booking-form__input${errors.email ? ' error' : ''}`}
        />
        {errors.email && <span className="booking-form__err">{errors.email}</span>}
      </div>

      <div className="booking-form__group">
        <label className="booking-form__label">Select Service *</label>
        <select
          name="service" value={form.service} onChange={handleChange}
          className={`booking-form__select${errors.service ? ' error' : ''}`}
        >
          <option value="">Choose a service…</option>
          {SERVICES.map(s => <option key={s} value={s}>{s}</option>)}
        </select>
        {errors.service && <span className="booking-form__err">{errors.service}</span>}
      </div>

      <div className="booking-form__row">
        <div className="booking-form__group">
          <label className="booking-form__label">Preferred Date *</label>
          <input
            type="date" name="date" value={form.date}
            min={today} onChange={handleChange}
            className={`booking-form__input${errors.date ? ' error' : ''}`}
          />
          {errors.date && <span className="booking-form__err">{errors.date}</span>}
        </div>
        <div className="booking-form__group">
          <label className="booking-form__label">Time *</label>
          <select
            name="time" value={form.time} onChange={handleChange}
            className={`booking-form__select${errors.time ? ' error' : ''}`}
          >
            <option value="">Choose a time…</option>
            {TIME_SLOTS.map(t => <option key={t} value={t}>{t}</option>)}
          </select>
          {errors.time && <span className="booking-form__err">{errors.time}</span>}
        </div>
      </div>

      <div className="booking-form__group">
        <label className="booking-form__label">Message (Optional)</label>
        <textarea
          name="message" value={form.message} onChange={handleChange}
          placeholder="Any special requests or notes…"
          className="booking-form__textarea"
          rows={3}
        />
      </div>

      <button type="submit" className="booking-form__submit" disabled={loading}>
        {loading ? (
          <><span className="spinner" /> Booking…</>
        ) : (
          '✦ Confirm Appointment'
        )}
      </button>
    </form>
  );
}
